import { createFileRoute } from '@tanstack/react-router'
import { SensorKitSyncPage } from '@/sync/SensorKitSyncPage'
import { installFlowSensorKitSerial } from '@/installFlow/storage-keys'

export const Route = createFileRoute('/sync/$sensorKitSerialNumber/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { sensorKitSerialNumber } = Route.useParams()

  installFlowSensorKitSerial.set(sensorKitSerialNumber);
  return <SensorKitSyncPage sensorKitSerialNumber={sensorKitSerialNumber} />
}
